/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClinicDocType = {
    FrontPhoto: 'Clinic Front Photo',
    InsidePhoto: 'Clinic Inside Photo',
    License: 'Clinic License'
} as const;
export type ClinicDocType = typeof ClinicDocType[keyof typeof ClinicDocType];


export function instanceOfClinicDocType(value: any): boolean {
    return Object.values(ClinicDocType).includes(value);
}

export function ClinicDocTypeFromJSON(json: any): ClinicDocType {
    return ClinicDocTypeFromJSONTyped(json, false);
}

export function ClinicDocTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClinicDocType {
    return json as ClinicDocType;
}

export function ClinicDocTypeToJSON(value?: ClinicDocType | null): any {
    return value as any;
}

